import { render } from "./ChannelActiveTime.vue?vue&type=template&id=0bdfe141&scoped=true"
import script from "./ChannelActiveTime.vue?vue&type=script&lang=js"
export * from "./ChannelActiveTime.vue?vue&type=script&lang=js"

import "./ChannelActiveTime.vue?vue&type=style&index=0&id=0bdfe141&lang=scss&scoped=true"
import "./ChannelActiveTime.vue?vue&type=style&index=1&id=0bdfe141&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdfe141"]])

export default __exports__